import { defineSlotRecipe } from '@chakra-ui/react';

export const accommodationItemSlotRecipe = defineSlotRecipe({
    slots: [
        'container',
        'image',
        'contentWrapper',
        'heading',
        'accommodationInfoWrapper',
        'cheapestRateAndRatingWrapper',
        'settlementNameContainer',
        'cheapestRateWrapper',
        'discountBadge',
        'discountBadgeWrapper',
        'reservationTypeBadge',
        'link',
        'badge',
    ],
    base: {
        container: {
            flexDirection: 'column',
            gap: 4,
            borderRadius: 'md',
            position: 'relative',
        },
        image: {
            width: '100%',
            height: '195px',
            rounded: 'xl',
            objectFit: 'cover',
        },
        contentWrapper: {
            flexDirection: 'column',
            height: 'full',
            gap: 1,
        },
        accommodationInfoWrapper: {
            minH: '65px',
            gap: 2,
        },
        heading: {
            lineClamp: 2,
            fontSize: {
                base: 'md',
                md: 'md',
            },
        },
        settlementNameContainer: {
            fontSize: 'xs',
            alignItems: 'center',
            gap: 2,
        },
        cheapestRateAndRatingWrapper: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            fontSize: 'md',
            marginTop: 'auto',
        },
        cheapestRateWrapper: {
            flexDirection: 'column',
            alignItems: 'flex-end',
            marginLeft: 'auto',
        },
        discountBadge: {
            colorPalette: 'brand',
        },
        discountBadgeWrapper: {
            minH: '30px',
            marginTop: '-34px',
        },
        link: {
            _before: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
            },
        },
    },
    variants: {
        variant: {
            map: {
                container: {
                    w: '300px',
                    backgroundColor: 'white',
                    borderRadius: 'xl',
                    overflow: 'hidden',
                },
                image: {
                    borderBottomRadius: '0',
                },
                contentWrapper: {
                    padding: 3,
                    paddingTop: 0,
                    gap: 2,
                },
                accommodationInfoWrapper: {
                    minH: 'unset',
                },
                reservationTypeBadge: {
                    zIndex: 2,
                    position: 'absolute',
                    top: 2,
                    left: 2,
                    width: '220px',
                    color: 'white',
                    colorPalette: 'green',
                    '& > span': {
                        fontSize: '0.8rem',
                        paddingBlock: '0.375rem',
                        paddingInline: '0.5rem',
                    },
                },
            },
            nearbyOta: {
                container: {
                    backgroundColor: 'white',
                    boxShadow: 'sm',
                    borderRadius: 'lg',
                    overflow: 'hidden',
                },
                image: {
                    borderRadius: '0',
                },
                contentWrapper: {
                    minH: '124px',
                    padding: 3,
                    paddingTop: 0,
                    gap: 2,
                },
            },
        },
    },
});
